<template>
    <div class="search_nav">
        <el-form :inline="true" class="demo-form-inline">
            <el-form-item label="发票类型：">
                <el-select style="width: 150px;" v-model="formInline.invoiceType" filterable placeholder="全部">
                    <el-option label="全部" value="" />
                    <el-option label="数电普票" :value="3" />
                    <el-option label="数电专票" :value="4" />
                </el-select>
            </el-form-item>
            <el-form-item label="开票类型：">
                <el-select style="width: 150px;" v-model="formInline.blueFlag" filterable placeholder="请选择">
                    <el-option label="全部" value="" />
                    <el-option label="蓝票" :value="1" />
                    <el-option label="红票" :value="2" />
                </el-select>
            </el-form-item>
            <el-form-item label="发票状态：">
                <el-select style="width: 150px;" v-model="formInline.invoiceState" filterable placeholder="请选择">
                    <el-option label="全部" value="" />
                    <el-option label="开票中" :value="0" />
                    <el-option label="开票成功" :value="1" />
                    <el-option label="开票失败" :value="2" />
                    <el-option label="发票作废" :value="5" />
                    <el-option label="未开票" :value="100" />
                </el-select>
            </el-form-item>
            <el-form-item label="开票时间：">
                <el-date-picker
                    v-model="formInline.dateRange"
                    type="daterange"
                    value-format="YYYY-MM-DD"
                    range-separator="至"
                    start-placeholder="起始日期"
                    end-placeholder="截止日期"
                    style="width: 280px;"
                />
                <el-button style="margin-left: 5px;" @click="setDate('month')">本月</el-button>
                <el-button @click="setDate('lastMonth')">上月</el-button>
                <el-button @click="setDate('year')">上一年</el-button>
            </el-form-item>
        </el-form>
        
        <el-form :inline="true" class="demo-form-inline" style="margin-top: 10px;">
            <el-form-item label="手机号：">
                <el-input style="width: 200px;" v-model="formInline.phoneNumber" placeholder="手机号" />
            </el-form-item>
            <el-form-item label="发票号码：">
                <el-input style="width: 200px;" v-model="formInline.invoiceNo" placeholder="发票号码" />
            </el-form-item>
            <el-form-item label="发票抬头：">
                <el-input style="width: 200px;" v-model="formInline.title" placeholder="发票抬头" />
            </el-form-item>
            <el-form-item label="通知邮箱：">
                <el-input style="width: 200px;" v-model="formInline.email" placeholder="通知邮箱" />
            </el-form-item>
            <el-form-item label="充电订单编号：">
                <el-input style="width: 250px;" v-model="formInline.tradeNo" placeholder="充电订单编号" />
            </el-form-item>
        </el-form>
  
        <div class="button_group">
            <el-button type="primary" @click="getList">搜索</el-button>
            <el-button type="primary" @click="getList">刷新</el-button>
            <!-- <el-button type="primary" @click="showAddInvoice()">录入发票</el-button> -->
            <el-button type="primary" @click="exportData">导出</el-button>
            <el-button type="primary" @click="downloadNewTemplate">下载模板</el-button>
            <el-button type="primary" @click="showBatchAddInvoice">批量新增发票</el-button>
            <!-- <el-button type="primary" @click="downloadTemplate">下载新电途模板</el-button> -->
            <!-- <el-upload
                    accept=".xlsx, .xls"
                    action=""
                    :http-request="importInvoice"
                    :limit="1"
                    :show-file-list="false"
                >
                <el-button type="primary">导入新电途</el-button>
            </el-upload> -->
        </div>
    </div>
  
    <el-table class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
      <el-table-column label="序号" width="60">
        <template #default="scope">
          <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="手机号" width="120">
        <template #default="scope">
          <span>{{ scope.row.phoneNumber || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="开票类型" width="100">
        <template #default="scope">
          <span>{{ scope.row.blueFlag === 1 ? '蓝票' : '红票' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="开票金额" width="100">
        <template #default="scope">
          <span>{{ scope.row.invoiceAmt === null || scope.row.invoiceAmt === '' || scope.row.invoiceAmt === undefined ? '--' : (scope.row.invoiceAmt || '-') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="电费" width="100">
        <template #default="scope">
          <span>{{ scope.row.elecFee === null || scope.row.elecFee === '' || scope.row.elecFee === undefined ? '--' : (scope.row.elecFee || '-') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="充电服务费" width="120">
        <template #default="scope">
          <span>{{ scope.row.svcFee === null || scope.row.svcFee === '' || scope.row.svcFee === undefined ? '--' : (scope.row.svcFee || '-') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="发票状态" width="100">
        <template #default="scope">
          <span>{{ statusFilter(scope.row.invoiceState) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="发票类型" width="130">
        <template #default="scope">
          <span>{{ scope.row.invoiceTypeStr || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="申请时间" width="180">
        <template #default="scope">
          <span>{{ scope.row.applyTime || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="开票时间" width="180">
        <template #default="scope">
          <span>{{ scope.row.invoiceTime || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="发票号码" width="230">
        <template #default="scope">
          <span>{{ scope.row.invoiceNo || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="发票抬头" width="200" show-overflow-tooltip>
        <template #default="scope">
          <span>{{ scope.row.title || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="联系电话" width="120">
        <template #default="scope">
          <span>{{ scope.row.phone || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="通知邮箱" width="250" show-overflow-tooltip>
        <template #default="scope">
          <span>{{ scope.row.email || '-' }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="操作人" width="100">
        <template #default="scope">
          <span>{{ scope.row.operator }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="操作" width="120" fixed="right">
        <template #default="scope">
          <el-button size="small" type="primary" @click="viewOrder(scope.row)">查看订单</el-button>
          <!-- <el-button size="small" type="success" @click="viewInvoice(scope.row)">查看发票</el-button>
          <el-button size="small" @click="resend(scope.row)">重新发送</el-button> -->
        </template>
      </el-table-column>
    </el-table>
  
    <!-- 分页 -->
    <Pagination
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
    />
  
    <!-- 录入发票弹窗 -->
    <el-dialog v-model="dialogFormVisible" :title="dialogTitle" width="600px" :close-on-click-modal="false" @closed="$refs.formDataRef?.clearValidate()">
        <el-form ref="formDataRef" :model="formData" :rules="formRules" label-position="right" label-width="120px">
            <el-form-item label="手机号：" prop="phoneNumber">
                <el-input v-model="formData.phoneNumber" placeholder="请输入手机号" />
            </el-form-item>
            <el-form-item label="开票单号：" prop="orderNo">
                <el-input v-model="formData.orderNo" placeholder="请输入开票单号" />
            </el-form-item>
            <el-form-item label="充电订单号：" prop="tradeIds">
                <!-- 多行输入框 -->
                <el-input v-model="formData.tradeIds" type="textarea" placeholder="请输入充电订单号" />
            </el-form-item>
        </el-form>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取消</el-button>
                <el-button type="primary" @click="saveInvoice">确定</el-button>
            </div>
        </template>
    </el-dialog>

    <!-- 批量新增发票弹窗 -->
    <el-dialog v-model="batchDialogFormVisible" title="批量新增发票" width="600px" :close-on-click-modal="false">
        <el-upload
            ref="batchUploadRef"
            class="upload-demo"
            drag
            accept=".xlsx, .xls"
            action=""
            :http-request="batchImportInvoice"
            :limit="1"
            :auto-upload="false"
            :on-change="handleFileChange"
            :file-list="batchFileList"
        >
            <el-icon class="el-icon--upload"><upload-filled /></el-icon>
            <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
            </div>
            <template #tip>
                <div class="el-upload__tip">
                    请上传Excel文件，支持 .xlsx 和 .xls 格式
                </div>
            </template>
        </el-upload>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="batchDialogFormVisible = false">取消</el-button>
                <el-button type="primary" @click="submitBatchImport" :disabled="!batchFileList.length">确定导入</el-button>
            </div>
        </template>
    </el-dialog>

    <!-- 查看订单弹窗 -->
    <el-dialog
        title="开票订单明细"
        v-model="orderDialogVisible"
        width="90%"
        :close-on-click-modal="false"
    >
        <el-table
            :data="orderList"
            :header-cell-style="{'text-align':'center'}"
            :cell-style="{'text-align':'center'}"
            style="width: 100%;"
        >
            <el-table-column label="充电订单编号" min-width="300" show-overflow-tooltip>
                <template #default="scope">
                    <span>{{ scope.row.tradeNo || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="场站" min-width="180" show-overflow-tooltip>
                <template #default="scope">
                    <span>{{ scope.row.stationName || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="充电量" width="100">
                <template #default="scope">
                    <span>{{ scope.row.chargeAmount || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="电费" width="100">
                <template #default="scope">
                    <span>{{ scope.row.elecFee || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="充电服务费" width="120">
                <template #default="scope">
                    <span>{{ scope.row.svcFee || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="充电服务费优惠" width="150">
                <template #default="scope">
                    <span>{{ scope.row.svcFeeDiscount || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="合计金额" width="100">
                <template #default="scope">
                    <span>{{ scope.row.totalAmount || '-' }}</span>
                </template>
            </el-table-column>

            <el-table-column label="跨月开票" width="100">
                <template #default="scope">
                    <span>{{ scope.row.crossMonth ? '是' : '否' }}</span>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <Pagination
            v-model:current-page="orderCurrentPage"
            v-model:page-size="orderPageSize"
            :total="orderTotal"
            @size-change="handleOrderSizeChange"
            @current-change="handleOrderCurrentChange"
        />
    </el-dialog>
  
  </template>
  
  <script>
  import { ElMessage } from 'element-plus';
  import { UploadFilled } from '@element-plus/icons-vue';
  import moment from 'moment';
  import { required, isMobile, isPhone } from '@/utils/validators';
  
  export default {
  name:'TicketManage',
  components: {
    UploadFilled
  },
  data() {
    return {
        dialogFormVisible: false,
        dialogTitle: '录入发票',
        tableData: [],
        total: 0,
        currentPage: 1,
        pageSize: 10,
        formInline: {
            invoiceType: '',
            blueFlag: '',
            dateRange: [],
            invoiceState: '',
            phoneNumber: '',
            invoiceNo: '',
            title: '',
            email: '',
            tradeNo: ''
        },
        formData: {
            phoneNumber: '',
            orderNo: '',
            tradeIds: ''
        },
        formDataRef: null,
        formRules: {
            phoneNumber: [required('请输入手机号'), isPhone('请输入正确的手机号或座机号')],
            orderNo: [required('请输入开票单号')],
            tradeIds: [required('请输入充电订单号')],
        },
        orderDialogVisible: false,
        orderList: [],
        orderTotal: 0,
        orderCurrentPage: 1,
        orderPageSize: 10,
        currentInvoiceId: '',
        batchDialogFormVisible: false,
        batchFileList: [],
        batchUploadRef: null
    }
  },
  mounted(){
    this.getList();
  },
  methods:{
    getList(){
        let that = this;
        let param = {};
        param.page = that.currentPage;
        param.pageSize = that.pageSize;
        param.dateType = 1;  //时间类型 1开票时间 2申请时间
        Object.keys(this.formInline).forEach(key => {
            if(key === 'dateRange' && this.formInline[key] && this.formInline[key].length > 0){
                param.startTime = this.formInline[key][0] + ' 00:00:00';
                param.endTime = this.formInline[key][1] + ' 23:59:59';
            } else if(this.formInline[key] !== '' && this.formInline[key] != null){
                if(key === 'tradeNo'){
                    param.tradeId = this.formInline[key];
                } else {
                    param[key] = this.formInline[key];
                }
            }
        });
        
        that.$axios.post(that.$store.state.platformApi + "invoiceRecord/page", JSON.stringify(param)).then(result => {
            if(result.code == 200){
                that.tableData = result.data.records;
                that.total = result.data.total;
            }
        });
    },
    handleSizeChange(val) {
        this.pageSize = val;
        this.getList();
    },
    handleCurrentChange(val) {
        this.currentPage = val;
        this.getList();
    },
    setDate(type) {
        let startDate, endDate;
        
        switch(type) {
           case 'month':
                // 本月
                startDate = moment().startOf('month').format('YYYY-MM-DD');
                endDate = moment().endOf('month').format('YYYY-MM-DD');
                break;
            case 'lastMonth':
                // 上一个月
                startDate = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
                endDate = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
                break;
            case 'year':
                // 去年
                startDate = moment().subtract(1, 'year').startOf('year').format('YYYY-MM-DD');
                endDate = moment().subtract(1, 'year').endOf('year').format('YYYY-MM-DD');
                break;
        }
        // console.log(startDate, endDate);
        this.formInline.dateRange = [
            startDate,
            endDate
        ];
    },
    showAddInvoice() {
        this.dialogTitle = '录入发票';
        this.formData = {
            phoneNumber: '',
            orderNo: '',
            tradeIds: ''
        };
        this.dialogFormVisible = true;
    },
    saveInvoice() {
        let that = this;
        // 表单校验
        this.$refs.formDataRef.validate((valid) => {
            if (!valid) return;
            that.formData.tradeIds = that.formData.tradeIds.split(',');
            that.$axios.post(that.$store.state.platformApi + "invoiceRecord/enter", JSON.stringify(this.formData)).then(result => {
                if(result.code == 200){
                    that.dialogFormVisible = false;
                    that.getList();
                    ElMessage({
                        message: '保存成功',
                        type: 'success'
                    });
                }
            });
        });
    },
    showBatchAddInvoice() {
        this.batchFileList = [];
        this.batchDialogFormVisible = true;
    },
    handleFileChange(file, fileList) {
        this.batchFileList = fileList;
    },
    batchImportInvoice(options) {
        // 批量导入发票
        let that = this;
        const formData = new FormData();
        formData.append('file', options.file);

        that.$axios.post(that.$store.state.platformApi + "invoiceRecord/batchImport", formData, {headers: {'Content-Type': 'multipart/form-data'}}).then(response => {
            // console.log('response--', response);
            if (response.code === 200) {
                that.batchDialogFormVisible = false;
                that.batchFileList = [];
                that.getList();
                ElMessage({
                    message: '批量导入成功',
                    type: 'success'
                });
            } else {
                ElMessage({
                    message: response.message || '批量导入失败',
                    type: 'error'
                });
            }
        }).catch(error => {
            console.error(error);
            ElMessage({
                message: '批量导入失败',
                type: 'error'
            });
        });
    },
    submitBatchImport() {
        if (this.batchFileList.length > 0) {
            this.$refs.batchUploadRef.submit();
        }
    },
    viewOrder(row) {
        // 查看订单
        this.currentInvoiceId = row.orderNo;
        this.orderCurrentPage = 1;
        this.orderDialogVisible = true;
        this.getOrderList();
    },
    getOrderList() {
        // 获取订单列表
        let that = this;
        let param = {};
        param.page = that.orderCurrentPage;
        param.pageSize = that.orderPageSize;
        param.orderNo = that.currentInvoiceId;
        
        that.$axios.post(that.$store.state.platformApi + "invoiceRecord/chargeOrder", JSON.stringify(param)).then(result => {
            if(result.code == 200){
                that.orderList = (result.data.records || []).map(item => ({
                    tradeNo: item.transactionId || '-',
                    stationName: item.stationName || '-',
                    chargeAmount: item.chargeQuantity !== null && item.chargeQuantity !== undefined ? item.chargeQuantity : '-',
                    elecFee: item.elecFee !== null && item.elecFee !== undefined ? item.elecFee : '-',
                    svcFee: item.svcFee !== null && item.svcFee !== undefined ? item.svcFee : '-',
                    svcFeeDiscount: item.discAmt !== null && item.discAmt !== undefined ? (item.discAmt === 0 ? '0.00' : item.discAmt) : '-',
                    totalAmount: item.discFee !== null && item.discFee !== undefined ? item.discFee : '-',
                    crossMonth: item.isCross == 1
                }));
                that.orderTotal = result.data.total || 0;
            }
        });
    },
    handleOrderSizeChange(val) {
        this.orderPageSize = val;
        this.getOrderList();
    },
    handleOrderCurrentChange(val) {
        this.orderCurrentPage = val;
        this.getOrderList();
    },
    viewInvoice(row) {
        // 查看发票 打开诺诺发票详情页
        window.open(row.invoiceUrl);
    },
    resend(row) {
        // 重新发送
        let that = this;
        let param = {};
        param.orderNo = row.orderNo;
        that.$axios.post(that.$store.state.platformApi + "invoiceRecord/delivery", JSON.stringify(param)).then(result => {
            if(result.code == 200){
                that.getList();
                ElMessage({
                    message: '发送成功',
                    type: 'success'
                });
            }
        });
    },
    downloadTemplate() {
        // 下载模板
        let that = this;
        that.$axios.post("/gateway/template/2", {}, {responseType: 'blob'}).then(result => {
            // 处理下载
        });
    },
    downloadNewTemplate() {
        // 下载模板
        let that = this;
        that.$axios.post("/gateway/template/4", {}, {responseType: 'blob'}).then(result => {
            // 处理下载
        });
    },
    importInvoice() {
        // 导入发票
        const formData = new FormData()
        formData.append('file', file.file)

        let that = this;
        this.$axios.post(that.$store.state.platformApi+"invoiceRecord/xdtImport", formData,{headers: {'Content-Type': 'multipart/form-data'}}).then(response => {
            // 处理上传成功后的响应
            // console.log(response.data)
            that.getList();
            ElMessage({
                message: '导入成功',
                type: 'success'
            });
        }).catch(error => {
            // 处理错误
            console.error(error)
        })
    },
    exportData() {
        // 导出
        let that = this;
        let param = {};
        param.dateType = 1;  //时间类型 1开票时间 2申请时间
        Object.keys(this.formInline).forEach(key => {
            if(key === 'dateRange' && this.formInline[key] && this.formInline[key].length > 0){
                param.startTime = this.formInline[key][0] + ' 00:00:00';
                param.endTime = this.formInline[key][1] + ' 23:59:59';
            } else if(this.formInline[key] !== '' && this.formInline[key] != null){
                if(key === 'tradeNo'){
                    param.tradeId = this.formInline[key];
                } else {
                    param[key] = this.formInline[key];
                }
            }
        });
        
        that.$axios.post(that.$store.state.platformApi + "invoiceRecord/export", JSON.stringify(param), {responseType: 'blob'}).then(result => {
            // 处理下载
        });
    },
    invoiceTypeFilter(value) {
        if(value == '1') return '数电普票';
        if(value == '2') return '数电专票';
        return '-';
    },
    statusFilter(value) {
        switch(value){
            case 0:
                return '开票中';
            case 1:
                return '开票成功';
            case 2:
                return '开票失败';
            case 5:
                return '发票作废';
            case 100:
                return '未开票';
            default:
                return '-';
        }
    },
  }
  }
  </script>
  
  <style lang="scss" scoped>
  .search_nav{
    // width: 100%;
    padding: 15px;
    background: #fff;
    margin-bottom: 15px;
  }
  // 全局搜索栏标签宽度 96px 只够 5 个汉字+冒号，这里放宽到 112px 容纳"充电订单编号："；
  // 选择器带 .demo-form-inline 提高优先级，否则会被后注入的 global-search.css 同优先级规则压回
  .search_nav .demo-form-inline :deep(.el-form-item__label){
    width: 112px;
    min-width: 112px;
  }
  .button_group{
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    button{
        margin-right: 10px;
    }
  }
    </style>